export const getIsTeacherFromSessionClaims = (
  sessionClaims: CustomJwtSessionClaims | null | undefined,
) => {
  const isFeideUser = sessionClaims?.publicMeta?.isFeideUser;
  const orgSlug = sessionClaims?.orgSlug;

  return !!(orgSlug || isFeideUser);
};
